export default __webpack_public_path__ + "static/media/ecomlogo.c877423a.svg";